import { Euler, Matrix4, Vector3, Vector3Like } from 'three'
import { productDistanceEngine } from '../lib/productDistanceEngine'

export function checkInFacility(points: Vector3Like[], center: Vector3Like, rotation: number) {
  const goToOrigin = new Matrix4().makeTranslation(-center.x, -center.y, -center.z)
  const rotate = new Matrix4().makeRotationFromEuler(new Euler(0, 0, rotation))
  const goFromOrigin = new Matrix4().makeTranslation(center.x, center.y, center.z)

  const mtx = new Matrix4()

  mtx.multiply(goFromOrigin)
  mtx.multiply(rotate)
  mtx.multiply(goToOrigin)

  const pt = new Vector3()
  for (const point of points) {
    pt.copy(point)
    pt.applyMatrix4(mtx)

    if (!productDistanceEngine.isWithinFacility(pt)) {
      return false
    }
  }
  return true
}
